import Vue from 'vue';
import Vuex from 'vuex';
import store from 'store';

import * as actions from './modules/actions/index';
import * as getters from './modules/getters/index';
import d2admin from './modules/d2admin';

Vue.use(Vuex);

// 应用初始状态
const state = {
  templates: [],
  clientApp: {
    appId: '',
    appTitle: '',
    bindApp: '',
    extAppid: '',
    typehood: '',
    weappTemplate: ''
  },
  peoples: [],
  autoStep: '',
  checkAuth: false,
  isSafe: false,
  isAgent: false,
  agents: []
};

// 定义所需的 mutations
const mutations = {
  setTemplates (state, list) {
    state.templates = list;
  },
  setClientAppMsg (state, msgObj) {
    state.clientApp = { ...msgObj };
  },
  setPeopleAll (state, list) {
    state.peoples = list;
  },
  setAutoSetStep (state, step) {
    state.autoStep = step;
  },
  checkRoleAuth (state, {
    customId
  }) {
    const checked = /^YH\d+/.test(customId);
    state.checkAuth = checked;
  },
  checkPass (state, password) {
    // 检测是否是纯数字
    const result = password !== undefined && isNaN(password);
    // 获取本地的保存态
    const storeSaveResult = store.get('isSafe');
    // 不是纯数字 true
    const isSafe = storeSaveResult || result;
    state.isSafe = isSafe;
    if (isSafe) {
      store.set('isSafe', true);
    }
  },
  checkAgent (state, me) {
    if (me) {
      state.isAgent = !!me.extra.agentId;
    } else {
      state.isAgent = true;
    }
    sessionStorage.setItem('haveChecked', true);
  },
  getAgentsList (state, list) {
    state.agents = list.map(l => ({
      title: l.title,
      agentId: l.agentId
    }));
  }
};

export default new Vuex.Store({
  modules: {
    d2admin
  },
  actions,
  getters,
  state,
  mutations
});
